/* eslint-disable no-use-before-define */
import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import UserItem from './UserItem';
import UserService from '../../../Services/userService';

class MassSupervisorEditWindowDescription extends React.Component {
  static titleForCreate = 'Mass Supervisor Edit';
  static titleForEdit = 'Mass Supervisor Edit';
  static ComponentName = '';
  static itemType = UserItem;
  static serviceFunction = UserService.MassSupervisorChange;

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OriginalSupervisorId',
          label: 'Original Supervisor',
          className: 'col-6',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'NewSupervisorId',
          label: 'New Supervisor',
          className: 'col-6',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
  ];
}

export default MassSupervisorEditWindowDescription;
